import { $http } from "@/plugins/api";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable: isIncidentsV3Available } = useFlag("INCIDENTS_V3");

const mailHistory = () => {
  return {
    totalEmailsAnalyzed: 0,
    totalIncidents: 0,
  };
};
const state = mailHistory();

const getters = {
  totalEmailsAnalyzed: (state) => state.totalEmailsAnalyzed,
  totalIncidents: (state) => state.totalIncidents,
};

const actions = {
  async getTotalEmailsAnalyzed({ commit }, { organisationId, params }) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT_V3
        }/history/${organisationId}/messages/count?${filterParams.toString()}`,
      );

      commit("setTotalEmailsAnalyzed", res.data.count);
    } else {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT
        }/v1/pt/history/platform/PhishTitan/type/General/globalOrganisationID/${organisationId}/count?${filterParams.toString()}`,
      );

      commit("setTotalEmailsAnalyzed", res.data.Count);
    }
  },
  async getTotalIncidents({ commit }, { organisationId, params }) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT_V3
        }/history/${organisationId}/incidents/count?${filterParams.toString()}`,
      );

      commit("setTotalIncidents", res.data.count);
    } else {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT
        }/v1/pt/history/platform/PhishTitan/type/Classified/globalOrganisationID/${organisationId}/count?${filterParams.toString()}`,
      );
      commit("setTotalIncidents", res.data.Count);
    }
  },
};

const mutations = {
  setTotalEmailsAnalyzed: (state, count) => (state.totalEmailsAnalyzed = count),
  setTotalIncidents: (state, count) => (state.totalIncidents = count),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
